// Copyright (c) 2026 WiseTime. All rights reserved.

export const storagePrefix = "wt_timeline_"

export const getCurrentSiteIdKey = (userId: string): string => `defaultOrg-${userId}`

// Timeline feature
// Important: changing WARN_MULTIPLE_TAGS value requires sync with wt-customer-frontend where it's reused in the internal logic
export const WARN_MULTIPLE_TAGS = storagePrefix + "warn_multiple_tags"
export const ACTION_PANE_NOTE_IS_HIDDEN = storagePrefix + "action_pane_note_is_hidden"
export const TILES_VIEW_TYPE = storagePrefix + "tiles_view_type"
export const GRID_TAGS_VIEW_TYPE = storagePrefix + "grid_tags_view_type"
export const TIMESHEET_FIELDS_VIEW_TYPE = storagePrefix + "timesheet_fields_view_type"
export const TIME_GROUPS_DISPLAY_MODE = storagePrefix + "time_groups_display_mode"
export const EMPTY_TRASH_DO_NOT_ASK_AGAIN_KEY = storagePrefix + "empty_trash_do_not_ask_again"
export const AUTO_NARRATIVE = storagePrefix + "auto_narrative"
export const TIMESHEET_FIELD_VIEW_MODE = storagePrefix + "timesheet_field_view_mode"
export const WELCOME_VIDEO_STATE_KEY = storagePrefix + "welcome_video_state"
export const CUSTOMER_USER_SIGNUP_TS_KEY = "wt_customer_user_signup_ts"

// Timeline toolbar
export const TOOLBAR_FILTERS_KEY = storagePrefix + "toolbar"

// Manual time feature
export const MANUAL_TIME_ACTIVITY = storagePrefix + "manual_time_activity"

// Tags feature
export const SEARCH_TAGS_ORDER_BY_KEY = storagePrefix + "search_tags_order_by"
export const RECENT_TAGS_ORDER_BY_KEY = storagePrefix + "recent_tags_order_by"
export const TAGS_VIEW_MODE = storagePrefix + "tags_view_mode"

// Sidebar
export const SIDEBAR_STORAGE_KEY = "WT_SIDEBAR_IS_COLLAPSED"

// Sanitized in App.tsx
export const staleLocalStorageKeys = [
  storagePrefix + "use_timesheet_fields",
  storagePrefix + "GRID_ACTIVITY_TYPES_VIEW_TYPE",
  storagePrefix + "search_activity_types_order_by",
  storagePrefix + "recent_activity_types_order_by",
  storagePrefix + "activity_types_view_mode",
]
